import { camelizeKeys } from 'humps';
import { postAsJson } from '@namespace/helpers';
import { IApiResponse } from '../../../types';

interface IGetGamesLiveData {
  providerIds: string[];
  internalGameIds: string[];
  currency: string;
}

export interface ISingleGameResponse {
  id: number;
  provider_id: number;
  internal_game_id: number;
  currency: string;
  language: string;
  min_bet?: string;
  max_bet?: string;
  table_open?: boolean;
  seats_total?: number;
  seats_available?: number;
  seats_taken?: number;
  updated_at: string;
  results: number[];
}

type GetGamesLiveDataResponseType = IApiResponse<{
  items: ISingleGameResponse[];
}>;

export const getGamesLiveData = ({
  providerIds = [],
  internalGameIds = [],
  currency
}: IGetGamesLiveData) => {
  // endpoint will return info about all games of given provider_ids + games from internal_game_ids
  return postAsJson<GetGamesLiveDataResponseType>(
    '/service/casino-live-data/v1/live-games/get-online-stats',
    {
      provider_ids: providerIds,
      internal_game_ids: internalGameIds,
      currency
    }
  ).then((res) => camelizeKeys<GetGamesLiveDataResponseType>(res));
};
